import _extends from "@babel/runtime/helpers/extends";
function isUndefined(val) {
  return typeof val === "undefined";
}
function mergeReportData(data1, data2) {
  var extend = undefined;
  if (data1.extend instanceof Object) {
    if (data2.extend instanceof Object) {
      extend = _extends({}, data1.extend, data2.extend);
    }
  } else {
    if (data2.extend instanceof Object) {
      extend = data2.extend;
    }
  }
  var reportData = _extends({}, data1, data2, {
    extend: extend
  });
  return reportData;
}
function armsTraceLog(response, armsTrace, cnReportData) {
  var _response$request = response.request,
    request = _response$request === void 0 ? {} : _response$request,
    _response$config = response.config,
    config = _response$config === void 0 ? {} : _response$config;
  var currentTime = new Date();
  var errorCode = cnReportData.errorCode,
    errorMsg = cnReportData.errorMsg,
    extend = cnReportData.extend,
    reportResponse = cnReportData.reportResponse;
  var recordInfo = request.__recordInfo__;
  if (!recordInfo) {
    recordInfo = {
      startTime: "-"
    };
  }
  var responseStr = "-";
  if (reportResponse === true) {
    responseStr = JSON.stringify(response);
  }
  var extendStr = "-";
  if (extend) {
    extendStr = JSON.stringify(extend);
  }
  armsTrace.logApi({
    success: false,
    url: config.url,
    httpCode: request.status,
    time: recordInfo.startTime === "-" ? "-" : currentTime.getTime() - recordInfo.startTime,
    requestType: "XHR",
    method: config.method,
    params: JSON.stringify(config.data),
    header: JSON.stringify(config.headers),
    response: responseStr,
    code: errorCode,
    msg: errorMsg,
    c1: "cn-request-auto",
    c2: extendStr
  });
}
function getCookie(cookieName) {
  var allCookies = window.document.cookie;
  var cookiePos = allCookies.indexOf(cookieName);
  var cookieVal = "";
  if (cookiePos != -1) {
    cookiePos = cookiePos + cookieName.length + 1;
    var cookieEnd = allCookies.indexOf(";", cookiePos);
    if (cookieEnd == -1) {
      cookieEnd = allCookies.length;
    }
    cookieVal = allCookies.substring(cookiePos, cookieEnd);
  }
  return cookieVal;
}
export { isUndefined, mergeReportData, armsTraceLog, getCookie };